import { render, staticRenderFns } from "./rollBackDailog.vue?vue&type=template&id=77c68b5c&scoped=true"
import script from "./rollBackDailog.vue?vue&type=script&lang=js"
export * from "./rollBackDailog.vue?vue&type=script&lang=js"
import style0 from "./rollBackDailog.vue?vue&type=style&index=0&id=77c68b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c68b5c",
  null
  
)

export default component.exports